// extracted by mini-css-extract-plugin
export default {"headerBox":"Header_headerBox__p1d-L"};